// extracted by mini-css-extract-plugin
export default {"sticky_first_column":"claimListTable_sticky_first_column__I73q6"};